export default "__VITE_ASSET__4a4191ec__"